module.exports = __webpack_public_path__ + "img/favorite.cd932550.svg";